import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { motion } from "framer-motion";

const APP_LINKS = {
  apple: "https://apps.apple.com/it/app/kairos-la-barberia/id6449093373",
  android: "https://play.google.com/store/apps/details?id=app.kairos.working&hl=it",
};

export const BookingDialog = ({ open, onOpenChange }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent 
        className="bg-kairos-gray border-white/10 max-w-md"
        data-testid="booking-dialog"
      >
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl text-center text-white">
            Prenota il tuo appuntamento
          </DialogTitle>
          <DialogDescription className="text-center text-white/60 mt-2">
            Scarica l'app per gestire in autonomia i tuoi appuntamenti
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 mt-6">
          <motion.a
            href={APP_LINKS.apple}
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className="flex items-center justify-center gap-4 bg-white text-kairos-black py-4 px-6 transition-all duration-300 hover:bg-white/90"
            data-testid="booking-apple-btn"
          >
            <svg className="w-8 h-8" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
            </svg>
            <div className="text-left">
              <p className="text-xs opacity-70">Scarica su</p>
              <p className="font-semibold text-lg">App Store</p>
            </div>
          </motion.a>

          <motion.a
            href={APP_LINKS.android}
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className="flex items-center justify-center gap-4 bg-kairos-gold text-kairos-black py-4 px-6 transition-all duration-300 hover:bg-kairos-gold-light"
            data-testid="booking-android-btn"
          >
            <svg className="w-8 h-8" viewBox="0 0 24 24" fill="currentColor">
              <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 01-.61-.92V2.734a1 1 0 01.609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.198l2.807 1.626a1 1 0 010 1.73l-2.808 1.626L15.206 12l2.492-2.491zM5.864 2.658L16.8 8.99l-2.302 2.302-8.634-8.634z"/>
            </svg>
            <div className="text-left">
              <p className="text-xs opacity-70">Disponibile su</p>
              <p className="font-semibold text-lg">Google Play</p>
            </div>
          </motion.a>
        </div>

        <p className="text-center text-white/40 text-xs mt-6">
          Oppure chiamaci al{" "}
          <a 
            href="tel:+393517252089" 
            className="text-kairos-gold hover:underline"
            data-testid="booking-phone-link"
          >
            +39 351 725 2089
          </a>
        </p>
      </DialogContent>
    </Dialog>
  );
};

export default BookingDialog;
